<template>
    <v-card class="mx-5 pb-5">
        <v-card-title class="px-5 pt-5 pb-4">
            <v-icon class="mr-3">mdi-table</v-icon>
            <span class="heebo fw600">Änderungen</span>
            <v-spacer></v-spacer>
            <v-text-field v-model="dateFrom" clearable hide-details class="mr-3" style="max-width: 190px"
                          label="von" type="date" filled dense/>
            <v-text-field v-model="dateUntil" clearable hide-details style="max-width: 190px"
                          label="bis" type="date" filled dense/>
        </v-card-title>
        <div class="text-right pr-5">
            <v-btn small @click="exportToExcel()" :disabled="!showTable && dateError" class="mr-3">
                <v-icon class="mr-1">mdi-download</v-icon>Excel Export</v-btn>
            <v-btn small color="primary" @click="getLog()" :disabled="!showTable && dateError">
                <v-icon class="mr-1">mdi-refresh</v-icon>Aktualisieren</v-btn>
        </div>
        <v-alert v-if="!showTable && dateError" text color="error" class="mx-5 my-3" icon="mdi-alert">
            {{dateError}}
        </v-alert>
        <div v-else-if="showTable" >
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder clearable
                          label="Suchen" filled single-line hide-details dense class="mx-5 mt-4"/>
            <v-data-table :headers="tableHeader" :items="items" class="mt-0" :search="search"
                          @current-items="getFiltered" :items-per-page="itemsPerPage"
                          sort-by="createdAt" :sort-desc="true" mobile-breakpoint="1">
                <template v-slot:item.changesRaw="{ item }">
                    <div :class="[{'changeCol': $vuetify.breakpoint.smAndUp}, 'my-3 px-4 grey lighten-5']">
                        <v-row v-for="(change, i) in item.changesRaw" :key="i">
                            <v-col class="pl-0 pr-1 py-1 font-weight-medium" cols="4">{{change.field}}:</v-col>
                            <v-col class="px-0 py-1 text-truncate" cols="3" v-if="change.valueOld">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{change.valueOld}}</span>
                                    </template>
                                    <span>{{change.valueOld}}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col class="px-0 py-1 text-center" cols="1" v-if="change.valueOld">-></v-col>
                            <v-col class="px-0 py-1 primary--text" :cols="change.valueOld?4:7">{{change.valueNew}}</v-col>
                        </v-row>
                    </div>
                </template>
                <template v-slot:no-data>
                    Für den gewählten Zeitraum wurden keine Änderungen gefunden!
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
    import SPIELER_ACTION_LISTS from "@/services/data/spielerAction/spielerActionLists";
    import TimeStamp from "@/services/timeStamp";
    import FirebaseRead from "@/services/database/firebaseRead";
    import EXCEL_DOWNLOAD from "@/utilities/services/downloads/excel/excelDownload";
    export default {
        name: "paesse-info-neu",
        data: () => ({
            log: [],
            tableHeader: [],
            items: [],
            filteredItems: [],
            // pagination
            dateFrom: '',
            dateUntil: '',
            dateError: '',
            showTable: false,
            search: null,
        }),
        created(){
            this.setDefaultReportTime()
        },
        computed: {
            dateJoined(){ return this.dateFrom + this.dateUntil},
            itemsPerPage(){ return this.search ? -1 : 10}
        },
        methods: {
            async getLog() {
                this.items = [];
                this.log = await FirebaseRead.readDocListDouble('spieler_actions',
                    [
                        {field: 'createdAt', operator: '>=', value: TimeStamp.getTimestampForDate('', this.dateFrom)},
                        {
                            field: 'createdAt',
                            operator: '<=',
                            value: TimeStamp.getTimestampForDate('until', this.dateUntil)
                        },
                    ]
                )
                this.createTable();
            },
            createTable(){
                this.items = [];
                this.tableHeader = SPIELER_ACTION_LISTS.getTableHeaders('paesseInfoNeu');
                this.createTableItems();
            },
            createTableItems(){
                this.log.forEach( (logItem) => {
                    let item  = SPIELER_ACTION_LISTS.getTableItem('paesseInfoNeu', logItem);
                    item.id = logItem.id
                    item.spielerFull += ' - ' +
                        this.$store.state.realtime.landesverbaende[logItem.status_lvNr].vereine[logItem.status_lvVerein.substring(2)].name

                    this.items.push(item);
                });
                this.items.sort((a, b) => a.ts < b.ts ? 1 : -1);
            },
            verifyDates(){
                this.dateError = ''
                this.log = []
                this.items = []
                this.showTable = false
            // no full dates
                if ( !this.dateFrom || !this.dateUntil ||
                     parseInt(this.dateFrom.substring(0,4)) < 2000 ||
                     parseInt(this.dateUntil.substring(0,4)) < 2000 ) return false
            // from > until
                if ( this.dateUntil < this.dateFrom ) {
                    this.dateError = 'Das von Datum muss größer als das bis Datum sein.'
                    return false
                }
            // more than seven days
                /*if ( TimeStamp.getTimestampForDate('until', this.dateUntil) -
                     TimeStamp.getTimestampForDate('', this.dateFrom) > 7 * 24 * 60 * 60 * 1000 ) {
                    this.dateError = 'Bitte nur maximal 7 Tage abfragen!'
                    return false
                }*/
                this.showTable = true
                this.getLog();
                return true
            },
            setDefaultReportTime(){
                this.dateUntil = TimeStamp.getTodayString()
                this.dateFrom = TimeStamp.getDateText(TimeStamp.getGMTTimestamp() - 6 * 24 * 60 * 60 * 1000)
            },
            exportToExcel() {
                if (this.log.length === 0) return
                const items = []
                this.log.forEach((logItem) => {
                    if (!this.search || this.filteredItems.findIndex(filteredItem => filteredItem.id === logItem.id) !== -1) {
                        let item = SPIELER_ACTION_LISTS.getTableItem('paesseInfoNeuExcel', logItem);
                        item.changesRaw = item.changesRaw.map((changes) => changes.field + ': ' +
                            changes.valueOld + ' -> ' +
                            changes.valueNew).join(', ')
                        item.vereinsName = this.$store.state.realtime.landesverbaende[logItem.status_lvNr].vereine[logItem.status_lvVerein.substring(2)].name
                        items.push(item);
                    }
                });
                EXCEL_DOWNLOAD.exportJsonToSingleSheet(
                    items, 'Änderungen_',
                    TimeStamp.getTodayString(),
                    SPIELER_ACTION_LISTS.getTableHeaders('paesseInfoNeuExcel'),
                );
            },
            getFiltered(items){
                this.filteredItems = items
            },
        },
        watch: {
            dateJoined(){ this.verifyDates() },
        }
    }
</script>

<style scoped>

</style>